import {
  takeLatest,
  call,
  put,
} from 'redux-saga/effects';

import types from '../types';
import actions from '../actions';

import stubResponse from '../data';

import { getKnowledgeCenterVideoApi } from '../../../api';

export const mockApi = () => ({
  data: stubResponse,
});

export function* getVideoFlow(action) {
  const id = action.id;

  try {
    const response = yield call(
      getKnowledgeCenterVideoApi,
      id,
    );
    yield put(
      actions.getVideoSucceeded(response.data),
    );
  } catch (error) {
    yield put(
      actions.getVideoFailed(error),
    );
  }
}

export function* watchGetVideoRequested() {
  yield takeLatest(
    types.GET_VIDEO_REQUESTED,
    getVideoFlow,
  );
}

export default watchGetVideoRequested;
